<template>
  <BRow class="mb-3">
    <BCol>
      <BInputGroup>
        <BFormInput
          :model-value="searchQuery"
          placeholder="Search by username, email, or display name..."
          @update:model-value="$emit('update:searchQuery', String($event))"
        />
        <BButton
          variant="primary"
          @click="$emit('reset-search')"
        >
          Clear
        </BButton>
      </BInputGroup>
    </BCol>
  </BRow>
</template>

<script setup lang="ts">
import { BRow, BCol, BFormInput, BButton, BInputGroup } from "bootstrap-vue-next";

defineProps<{
  searchQuery: string;
}>();

defineEmits<{
  "update:searchQuery": [value: string];
  "reset-search": [];
}>();
</script>
